function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { receiveRecordDetailApi } from '../../api';
import { formatToYuan } from '@/utils/amount';
export default {
  name: 'ReceiveRecordDetail',
  data: function data() {
    return {
      visible: false,
      loading: false,
      detail: {},
      baseInfo: {}
    };
  },
  computed: {
    statusTagType: function statusTagType() {
      var status = (this.detail.statusDesc || this.baseInfo.statusDesc || '') + '';
      if (status.includes('未') || status.includes('待')) return 'info';
      if (status.includes('成') || status.includes('已')) return 'success';
      if (status.includes('失效') || status.includes('失')) return 'danger';
      return 'primary';
    },
    formatValidity: function formatValidity() {
      if (this.detail.validityStart && this.detail.validityEnd) {
        return "".concat(this.detail.validityStart, " \u81F3 ").concat(this.detail.validityEnd);
      }
      if (this.detail.validityDays) {
        return "\u9886\u53D6\u540E".concat(this.detail.validityDays, "\u5929");
      }
      if (this.baseInfo.validityStart && this.baseInfo.validityEnd) {
        return "".concat(this.baseInfo.validityStart, " \u81F3 ").concat(this.baseInfo.validityEnd);
      }
      if (this.baseInfo.validityDays) {
        return "\u9886\u53D6\u540E".concat(this.baseInfo.validityDays, "\u5929");
      }
      return '--';
    },
    // Prefer new fields if present
    formatLocationAddress: function formatLocationAddress() {
      return this.detail.locationAddress || this.detail.location || this.baseInfo.location || '--';
    },
    // Return a printable coordinate string from various possible fields
    formatCoordinateString: function formatCoordinateString() {
      var coords = this.parseCoordinates();
      if (!coords) return '--';
      return "".concat(coords.lat, ", ").concat(coords.lng);
    },
    hasCoordinates: function hasCoordinates() {
      return !!this.parseCoordinates();
    }
  },
  methods: {
    open: function open(row) {
      this.visible = true;
      this.baseInfo = row || {};
      this.detail = {};
      if (row && row.id) {
        this.fetchDetail(row.id);
      }
    },
    fetchDetail: function () {
      var _fetchDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(recordId) {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.loading = true;
              _context.p = 1;
              _context.n = 2;
              return receiveRecordDetailApi(recordId);
            case 2:
              res = _context.v;
              this.detail = res || {};
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              this.$message.error('获取详情失败');
            case 4:
              _context.p = 4;
              this.loading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function fetchDetail(_x) {
        return _fetchDetail.apply(this, arguments);
      }
      return fetchDetail;
    }(),
    formatValue: function formatValue(key) {
      return this.detail[key] || this.baseInfo[key] || '--';
    },
    // Try to parse coordinates from several possible formats:
    // - detail.longitude & detail.latitude
    // - detail.longitudeLatitude (comma or space separated)
    // - detail.longitudeLatitude could be "lng,lat" or "lat,lng" — detect by magnitude (lat range -90..90)
    parseCoordinates: function parseCoordinates() {
      var rawCoord = this.detail.longitudeLatitude || "".concat(this.detail.longitude || '', ",").concat(this.detail.latitude || '');
      if (!rawCoord) return null;
      var nums = ('' + rawCoord).match(/-?\d+(\.\d+)?/g);
      if (!nums || nums.length < 2) return null;
      var a = parseFloat(nums[0]);
      var b = parseFloat(nums[1]);
      // determine which is lat/lng: lat must be between -90 and 90
      // if first value is inside lat range and second not, assume (lat,lng)
      if (Math.abs(a) <= 90 && Math.abs(b) <= 180 && Math.abs(b) > 90) {
        return {
          lat: a,
          lng: b
        };
      }
      // if second is lat
      if (Math.abs(b) <= 90 && Math.abs(a) <= 180 && Math.abs(a) > 90) {
        return {
          lat: b,
          lng: a
        };
      }
      // otherwise guess typical order lng,lat -> convert to lat,lng
      // many systems store as lng,lat; if both plausible, assume first is lng
      return {
        lng: a,
        lat: b
      };
    },
    formatCoordinate: function formatCoordinate() {
      var coords = this.parseCoordinates();
      if (!coords) return '--';
      return "".concat(coords.lng, ", ").concat(coords.lat);
    },
    formatAmount: function formatAmount(value) {
      if (value === undefined || value === null) return '--';
      return formatToYuan(value, {
        fractionDigits: 2
      });
    },
    copyCoordinates: function copyCoordinates() {
      var _this = this;
      var coords = this.parseCoordinates();
      if (!coords) {
        this.$message.warning('无可复制的坐标');
        return;
      }
      var text = "".concat(coords.lng, ",").concat(coords.lat);
      if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(function () {
          _this.$message.success('经纬度已复制');
        }).catch(function () {
          _this.fallbackCopy(text);
        });
      } else {
        this.fallbackCopy(text);
      }
    },
    copyRowInfo: function copyRowInfo() {
      var _this2 = this;
      var lines = ["\u4F18\u60E0\u5238\uFF1A".concat(this.formatValue('couponName')), "\u9886\u53D6\u4EBA\uFF1A".concat(this.formatValue('receiver')), "\u9886\u53D6\u65F6\u95F4\uFF1A".concat(this.formatValue('receiveTime')), "\u5B9A\u4F4D\u5730\u5740\uFF1A".concat(this.formatLocationAddress), "\u7ECF\u7EAC\u5EA6\uFF1A".concat(this.formatCoordinateString)];
      var text = lines.join('\n');
      if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(function () {
          _this2.$message.success('信息已复制到剪贴板');
        }).catch(function () {
          _this2.fallbackCopy(text);
        });
      } else {
        this.fallbackCopy(text);
      }
    },
    fallbackCopy: function fallbackCopy(text) {
      try {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.style.position = 'fixed';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        this.$message.success('已复制');
      } catch (e) {
        this.$message.error('复制失败');
      }
    },
    openInMap: function openInMap() {
      var coords = this.parseCoordinates();
      if (!coords) {
        this.$message.warning('无坐标可打开地图');
        return;
      }
      // Prefer Google Maps query (lat,lng) — works internationally.
      // If you prefer AMap/Baidu for China, replace URL accordingly.
      var lat = coords.lat;
      var lng = coords.lng;
      var url = "https://www.google.com/maps/search/?api=1&query=".concat(lat, ",").concat(lng);
      window.open(url, '_blank');
    }
  }
};